import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import TermsAndConditions from './TermsAndConditions';
import config from '../../config';
import { HTMLTrans, TransLink } from '../Common/Translations';

const PromotionGroupInfo = props => (
  <div>
    <div className='mt-5'>
      <p className='ProximaNova-Bold mb-2'><HTMLTrans id="promotion.promotiongroupinfo_title">Your purchase comes with:</HTMLTrans></p>
      <HTMLTrans id="promotion.promotiongroupinfo_h6">
        <ul className='pl-5'>
          <li>An email containing your discount voucher.</li>
          <li>Shipping fee is not included.</li>
        </ul>
      </HTMLTrans>
    </div>
    <div>
      <small className='bulk-info__text'>
        <img src={`${config.s3BucketUrl}/assets/general/question-icon.svg`} className="bulk-info__icon mr-2"/><HTMLTrans id="promotion.promotiongroupinfo_bulk_info">Need more quantity? Check out our <TransLink url='/bulk-discount' target='_blank'>bulk prepaid discount!</TransLink></HTMLTrans>
      </small>
    </div>
    <div className='mt-4'>
      <small className='bulk-info__text'>
        <HTMLTrans id="promotion.promotiongroupinfo_bulk_info_2" variables={{"currency": props.store.currency.code, "store": props.store.name}}>All prices are in {props.store.currency.code}. Valid for {props.store.name} only.</HTMLTrans>
        <TermsAndConditions contents={props.termsAndConditions} id={props.id} tncText={<HTMLTrans id="promotion.promotiongroupinfo_tnc_text">Terms and conditions apply.</HTMLTrans>}/>
      </small>
    </div>
  </div>
);

PromotionGroupInfo.PropTypes = {
  termsAndConditions: PropTypes.string,
  id: PropTypes.number.required,
  store: PropTypes.shape({
    name: PropTypes.string.required,
    currency: PropTypes.shape({
      code: PropTypes.string.required,
    }).required,
  }).required,
};

export default PromotionGroupInfo;



// WEBPACK FOOTER //
// ./src/Promotion/PromotionGroupInfo.js